export const TRACER_VISION = "TracerVision™";
export const FOUR_D_VISUALISATION = "4D Visualisations";
